

























import { Component, Vue, Prop } from "vue-property-decorator";
import { Getter, Action } from "vuex-class";
import { Ladder } from '@/common/interface/group_type';

@Component
export default class Radio extends Vue {
  @Prop({ required: true })
  radioList!: Array<object>;
  @Prop()  _style!: object;

  @Getter("payType")
  payType!: string;
  @Getter('ladderGroupList')
  ladderGroupList!: Array<Ladder>

  handleChangePayType(item: any): void {
    if (this.ladderGroupList.length > 1 && item.value === '拼团价') return;
    this.$emit("_change", item);
  }
}
